export default {
  default: {
    blankState: {
      title: 'No Templates',
      paragraph: 'Templates can be created in Admin settings.',
    },
    button: 'Create Templates',
  },
}
